export default () => {
  const container = document.querySelector('.banner__search');
  const input = container.querySelector('.search-form__input');
  const openBtn = container ? container.querySelector('.btn-open-search') : null;
  let isOpen = false;

  const open = () => {
    container.classList.add('is-open');
    if( input ) {
      input.focus();
    }
    isOpen = true;
  };

  const close = () => {
    container.classList.remove('is-open');
    if( input ) {
      input.blur();
    }
    isOpen = false;
  };

  if( openBtn ) {
    openBtn.addEventListener('click', event => {
      event.preventDefault();
      if( isOpen ) {
        close();
      } else {
        open();
      }
    })
  }
}
